import styled from "styled-components";
import { theme } from "@byko/lib-styles";

export const ChatContainer = styled.div`
  position: fixed;
  z-index: 1000;
  right: 20px;
  bottom: 100px;
  display: flex;
  width: 350px;
  height: 500px;
  flex-direction: column;
  background: white;
`;

export const ChatHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background: ${theme.palette.blue.dark};
  color: red;
`;

export const ChatSelect = styled.div`
  display: flex;
  align-items: center;
  padding: 15px;
  background: white;
  gap: 8px;
  .input-wrapper {
    padding-bottom: 0 !important;
  }
  & > input {
    flex: 0 1 75%;
  }
  & > button {
    height: 56px;
    flex: 0 1 25%;
  }
`;

export const SendButton = styled.button`
  display: flex;
  width: 48px;
  height: 40px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  border-radius: 20px;
  background: ${theme.palette.yellow.main};
  color: ${theme.palette.blue.dark};
  cursor: pointer;
  font: inherit;
  transition: background 0.2s;
  & > svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: ${theme.palette.blue.dark};
    fill: ${theme.palette.blue.dark};
  }
  &:hover {
    background: ${theme.palette.yellow.dark};
  }
`;

export const ChatBox = styled.div`
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  padding: 20px;
  background: ${theme.palette.white.main};
  overflow-y: scroll;
`;

export const ChatContentContainer = styled.div``;

export const chatWidgetStyles = {
  inputArea: {
    padding: 15,
    background: "white",
    borderTop: "1px solid #dee2e6",
    display: "flex",
    alignItems: "center",
  },
  messageInput: {
    flex: 1,
    padding: 10,
    border: "1px solid #dee2e6",
    borderRadius: 20,
    outline: "none",
  },
  sendButton: {
    marginLeft: 8,
  },
  humanMessage: {
    background: "#007bff",
    color: "white",
    marginLeft: "auto",
    marginBottom: 10,
    maxWidth: "80%",
    padding: "10px 15px",
    borderRadius: 15,
  },
  agentMessage: {
    background: theme.palette.blue.light, // Use a blue from the theme
    color: theme.palette.blue.dark,
    marginRight: "auto",
    marginBottom: 10,
    maxWidth: "80%",
    padding: "10px 15px",
    borderRadius: 15,
  },
  botMessage: {
    background: "#e9ecef",
    color: "#333",
    marginRight: "auto",
    marginBottom: 10,
    maxWidth: "80%",
    padding: "10px 15px",
    borderRadius: 15,
  },
};

export const headerContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
};

export const h2Style = { margin: 0, fontSize: 18, flex: 1 };
export const headerButtonGroupStyle = { display: "flex", alignItems: "center", gap: 4 };
export const headerButtonStyle = {
  width: 24,
  height: 24,
  border: "none",
  background: "transparent",
  color: theme.palette.yellow.dark,
  fontSize: 18,
  cursor: "pointer",
  marginRight: 2,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
export const headerButtonStyleNoMargin = {
  ...headerButtonStyle,
  marginRight: 0,
};

export const headerButtonSpanStyle = { fontWeight: "bold" };

export const DepartmentSelectStyle = styled.div`
  position: fixed;
  z-index: 1001;
  right: 20px;
  bottom: 100px;
  display: flex;
  width: 350px;
  height: 500px;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 0;
  border-radius: 10px;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const DepartmentModalBodyStyle = styled.div`
  padding: 24px;
`;

export const Nickname = styled.div`
  margin-bottom: 5;
  font-size: "0.8em";
  font-weight: bold;
  opacity: 0.8;
`;

export const DepartmentLabelTitle = styled.div`
  width: 111px;
  height: 31px;
  flex: none;
  flex-grow: 0;
  align-self: stretch;
  order: 0;
  color: #0a3a5c;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 170%;
`;
export const DepartmentLabelField = styled.div`
  display: flex;
  width: 100%;
  height: 56px;
  box-sizing: border-box;
  flex: none;
  flex-direction: row;
  flex-grow: 0;
  align-items: center;
  align-self: stretch;
  order: 1;
  padding: 15px 24px 14px;
  border: 1px solid #e6e7e8;
  background: #ffffff;
  gap: 204px;
`;
export const DepartmentLabelPlaceholder = styled.div`
  width: 100%;
  height: 27px;
  flex: none;
  flex-grow: 0;
  align-self: stretch;
  order: 0;
  color: #0a3a5c;
  font-family: "DIN Next LT Pro", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 170%;
`;

export const Deild = styled.div`
  margin-top: 12px;
  & button {
    border-top: none !important;
  }
`;

export const attachmentStyle = { marginTop: 8 };
export const agentTypingStyle = { color: "#667", fontStyle: "italic", marginTop: 8 };
export const hiddenInputStyle = { display: "none" };

export const Text = styled.p`
  margin: 1rem;
  color: ${theme.palette.blue.dark};
  font-size: 16px;
  text-align: center;
  user-select: none;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin: 16px 0;
`;

// Add a styled component for the avatar image or icon
export const AgentAvatar = styled.span`
  display: flex;
  width: 42px;
  min-width: 42px;
  max-width: 42px;
  height: 42px;
  min-height: 42px;
  max-height: 42px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 50%;
  margin-right: 8px;
  background: ${theme.palette.blue.dark};
  object-fit: cover;
  & > svg {
    display: block;
    width: 24px;
    height: 24px;
  }
`;

// Update ChatBox message rendering styles for alignment
export const MessageContainer = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
`;

export const HumanMessage = styled.div`
  display: flex;
  max-width: "80%";
  align-items: center;
  padding: "10px 15px";
  border-radius: 15px;
  margin-left: "auto";
  background: "#007bff";
  color: "white";
`;

export const AgentMessage = styled.div`
  display: flex;
  max-width: "80%";
  align-items: center;
  padding: "10px 15px";
  border-radius: 15px;
  margin-right: "auto";
  background: "#28a745";
  color: "white";
`;

export const BotMessage = styled.div`
  display: flex;
  max-width: "80%";
  align-items: center;
  padding: "10px 15px";
  border-radius: 15px;
  margin-right: "auto";
  background: "#e9ecef";
  color: "#333";
`;

// Add styles for chat message alignment and bubbles
export const ChatMessageAgent = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  margin-bottom: 10px;
`;

export const ChatMessageUser = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-bottom: 10px;
`;

export const ChatBubbleAgent = styled.div`
  display: flex;
  max-width: 80%;
  flex-direction: column;
  padding: 10px 15px;
  border-radius: 15px;
  margin-right: auto;
  margin-left: 0;
  background: ${theme.palette.gray[10]};
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const ChatBubbleUser = styled.div`
  display: flex;
  max-width: 80%;
  flex-direction: column;
  align-items: flex-end;
  padding: 10px 15px;
  border-radius: 15px;
  margin-right: 0;
  margin-left: auto;
  background: ${theme.palette.yellow.main};
  overflow-wrap: anywhere;
  word-break: break-word;
`;

// Styled label for file input, with prop for icon color
export const ChatFileLabel = styled.label`
  position: absolute;
  top: 4px;
  right: 2px;
  display: flex;
  width: 44px;
  min-width: 44px;
  height: 44px;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  padding-right: 0;
  color: ${theme.palette.blue.main};
  cursor: pointer;
`;

export const DisconnectConfirmWrapper = styled.div`
  position: absolute;
  z-index: 2000;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
`;

export const DisconnectConfirmBox = styled.div`
  display: flex;
  width: 320px;
  max-width: 90%;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  border-radius: 8px;
  background: white;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.15);
`;

export const DisconnectConfirmText = styled.div`
  margin-bottom: 24px;
`;

export const DisconnectConfirmButtonRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  margin-top: 16px;
  gap: 12px;
`;

export const chatSendButtonStyle: React.CSSProperties = { height: 44, width: 44 };
